import DepsService from 'services/dependencies';
import {
  INSTANT_GAME_TYPE,
  DRAW_GAME_TYPE,
  VLT_GAME_TYPE,
} from '../actions/game-images.actions';

const CONTEXT = 'game-images';

export const getGameType = (type) => {
  switch (type) {
    case INSTANT_GAME_TYPE:
      return 'S';
    case DRAW_GAME_TYPE:
      return 'O';
    case VLT_GAME_TYPE:
      return 'V';
    default:
      return 'V';
  }
};

export const fetchGameImages = async (type, params) => {
  const { url } = DepsService.rest.cms.gameImages.get;
  const queryParams = { ...params };
  const urlParams = { type };
  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const updateGameImages = async (type, gameId, image) => {
  const { url } = DepsService.rest.cms.gameImages.update;
  const queryParams = { image };
  const gameType = getGameType(type);
  const urlParams = { gameType, gameId };

  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/app/resources/game-images.api.js